<template>
    <tq-loader-container :p_show-loader_b="server_currentUserData_c == null || server_questBody_c == null" class="TQ_center" :p_tq-loader_b="true">
        <div class="lc_ongoingChat TQ_maxWidth_600px TQ_borderBox TQ_bg_white TQ_padding_8px TQ_minHeight_bodyFullScreen TQ_inline TQ_width_100p"
             v-if="server_currentUserData_c != null && server_questBody_c != null">

            <tq-chat_messages class="lc_chatMessages"
                              :class="store_system_windowSizeType_ve.val>enum_screenSizesOptions_n.mobile ? 'TQ_text_24px' : 'TQ_text_16px'"
                              :p_current-user_c="server_currentUserData_c"
                              :p_system-lang-code_e="store_system_langCode_ve.val"
                              :p_creator-id_uid="store_questEvent_c.qev_creatorId_uid"
                              :p_messages_by-send-time_c="server_messages_bySendTime_c"
                              :p_all-player-join-time_by-player-id_c="co_players_byUserId_c"
                              :p_msg-show-translate_by-msg-time_b="store_msgShowTranslate_v_byMsgTime_b.val"
                              :p_show-translation_b="server_questBody_c.qb_metadata_c.qbm_quest_supportChatTranslate_b"

                              :pe_translate-msg_f="m_translateMsg_fs">

            </tq-chat_messages>

            <div class="lc_sendMsg">

                <tq-chat_input-bar
                    class="TQ_maxWidth_600px TQ_center"
                    :p_current-user_c="server_currentUserData_c"
                    :p_system-lang-code_e="store_system_langCode_ve.val"
                    :p_big-mode_b="store_system_windowSizeType_ve.val>enum_screenSizesOptions_n.mobile"
                    :p_bottom-notification_n="bottomNotification_n"
                    :p_chat-scroll-to-bottom_b="chatScrollToBottom_b"

                    :pe_send-message_f="m_userEvents_sendMessage_f"
                    :pe_scroll-down_f="route_scrollToBottom_f"
                />
            </div>

        </div>
    </tq-loader-container>
</template>

<script>
    import TqChat_inputBar from "../../components/complex/TqChat_inputBar";
    import TqChat_messages from "../../components/complex/TqChat_messages";
    import {
        serverOngoing_chatMessages_cl_remove,
        serverOngoing_chatMessages_cl_set_f,
        serverOngoing_chatMessage_read_f,
        serverOngoing_chatMessage_send_f,
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_gameStatus_vl_remove_f,
        serverOngoing_chatMessage_translate_f,
    } from "../../scripts/Server/S_ServerOngoing";
    import {
        enum_moveToOptions,
        enum_eventsListenersNames,
        enum_screenSizesOptions_n
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "../../store";
    import {route_currentPath_s, route_scrollToBottom_f} from "../../router";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "../../scripts/Server/S_ServerAuth";
    import {date_setTimeout} from "../../scripts/S_Date";
    import {
        eventListener_addEventListenerToObj,
        eventListener_removeEventListenerToObj
    } from "../../scripts/S_EventListeners";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVirables";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {serverBig_questBody_once_fp} from "@/scripts/Server/S_ServerFirestore";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";

    export default {
        name: "v_Ongoing_Chat",
        components: {
            TqLoaderContainer,
            TqChat_inputBar,
            TqChat_messages
        },
        data(){
            return {

                bottomNotification_n     : 0,
                chatScrollToBottom_b     : false,
                currentViewIsActivated_b : false,

                // store
                store_system_langCode_ve:       store_getStateValue_vo(store_var.system_langCode),
                store_questEvent_c :            store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid:        store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_windowSizeType_ve: store_getStateValue_vo(store_var.system_windowSizeType_e),
                store_msgShowTranslate_v_byMsgTime_b: store_getStateValue_vo(store_var.ongoing_chat_msgShowTranslate_byMsgTime_b),

                // server
                server_questBody_c    : undefined,
                server_currentUserData_c    : undefined,
                server_gameStatus_p         : undefined,
                server_messages_bySendTime_c: {},
                route_scrollToBottom_f      : route_scrollToBottom_f,

                // import
                enum_screenSizesOptions_n : enum_screenSizesOptions_n
            }
        },
        computed : {
            co_players_byUserId_c(){
                if(this.server_gameStatus_p === undefined){
                    return {}
                }
                return this.server_gameStatus_p.gs_teams_byTeamId[this.store_currentTeamId_uid].gst_players_byUserId_c
            }
        },
        methods:{

            m_userEvents_sendMessage_f(msg_c){

                serverOngoing_chatMessage_send_f(this.store_questEvent_c, this.store_currentTeamId_uid, msg_c, () =>{})

                date_setTimeout(() => {
                    route_scrollToBottom_f();
                }, 500, this.$options.name)
 
            },
            m_sendReadMessages_f(){

                // check ongoing_chat url
                if(!route_currentPath_s(this.$route).includes(enum_moveToOptions.ongoing_chat)
                    || this.server_currentUserData_c == null){
                    return
                }

                for(const key in this.server_messages_bySendTime_c){

                    serverOngoing_chatMessage_read_f(
                        this,
                        this.store_questEvent_c,
                        this.store_currentTeamId_uid,
                        this.server_messages_bySendTime_c[key],
                        this.server_currentUserData_c.ud_userId_uid)
                }
            },
            m_setMessagesListener_f(currentUserData_c){

                serverOngoing_chatMessages_cl_set_f(
                    this.$options.name,
                    currentUserData_c.ud_userId_uid,
                    this.store_questEvent_c,
                    this.store_currentTeamId_uid,
                    newMsg_c => {

                        this.$set(this.server_messages_bySendTime_c, newMsg_c.ms_sendTime_n, newMsg_c)

                        if(newMsg_c.ms_readMsg_byUserId_b[currentUserData_c.ud_userId_uid] == null){
                            this.bottomNotification_n++

                            date_setTimeout(() => {
                                this.m_onScrollChangeDo_f()
                            },100, this.$options.name)
                        }


                        if(this.currentViewIsActivated_b){
                            serverOngoing_chatMessage_read_f(
                                this,
                                this.store_questEvent_c,
                                this.store_currentTeamId_uid,
                                newMsg_c,
                                this.server_currentUserData_c.ud_userId_uid)

                        }
                    })
            },
            m_onScrollChangeDo_f(){
                this.chatScrollToBottom_b = (window.innerHeight + window.scrollY) >= document.body.offsetHeight - gv_numbers.chatSaveDistance

                if(this.chatScrollToBottom_b){
                    this.bottomNotification_n = 0
                }
            },

            async m_translateMsg_fs(msg_c){

                // update store
                this.$set(this.store_msgShowTranslate_v_byMsgTime_b.val, msg_c.ms_sendTime_n, true)
                store_setStateValue(store_var.ongoing_chat_msgShowTranslate_byMsgTime_b, this.store_msgShowTranslate_v_byMsgTime_b.val)

                // if dont have translate
                if(msg_c.ms_translate_blc_s[this.store_system_langCode_ve.val] == null){
                    this.$set(msg_c.ms_translate_blc_s, this.store_system_langCode_ve.val, ass_strings.oneWord_loading[this.store_system_langCode_ve.val] + "...")

                    await serverOngoing_chatMessage_translate_f(this.store_questEvent_c, this.store_currentTeamId_uid, msg_c, this.store_system_langCode_ve.val, () => {})
                }

            }
        },

        // life circle
         created() {

             // 1) get quest body
             serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true,questBody_c => {
                 this.server_questBody_c = questBody_c;
             })

            // 1) get currentUserData
             let initOnce_b = false
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {

                this.server_currentUserData_c = currentUserData;

                if (initOnce_b || this.server_currentUserData_c == null) {
                    return
                }
                initOnce_b = true

                // 1 set message listener
                this.m_setMessagesListener_f(this.server_currentUserData_c)

                // 3) get game status
                serverOngoing_gameStatus_vl_set_f(this.$options.name,
                    this.store_questEvent_c.qev_questType_e,
                    this.store_questEvent_c.qev_questId_uid,
                    this.store_questEvent_c.qev_eventId_uid,
                    true,
                    (gameStatus_c) => {
                        this.server_gameStatus_p = gameStatus_c
                    })




            })

        },
        activated(){
            this.m_sendReadMessages_f()
            this.currentViewIsActivated_b = true




            // add scroll listener
            eventListener_addEventListenerToObj(window, enum_eventsListenersNames.scroll, true, this.$options.name, () => {
                this.m_onScrollChangeDo_f()
            })



        },
        deactivated(){

            this.currentViewIsActivated_b = false

            // remove scroll listener
            eventListener_removeEventListenerToObj(window, enum_eventsListenersNames.scroll, this.$options.name)
        },

        destroyed(){

            // 1) remove chat messages
            serverOngoing_chatMessages_cl_remove(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            // 2) remove currentUserData Listener
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 3) remove game status
            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent_c)
        },


    }
</script>

<style scoped lang="scss">


    .lc_chatMessages{
        margin-bottom:40px;
    }

    .lc_sendMsg{
        position: fixed;
        bottom: var(--bottomBar);

        width: 100%;
        left: 0;
    }




</style>